export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_THEME = 'UPDATE_THEME';
export const UPDATE_ACTIVE_MODAL = 'UPDATE_ACTIVE_MODAL';
export const TOGGLE_APP_DRAWER = 'TOGGLE_APP_DRAWER';